import {MoodType} from '../../../types/MoodType';

// Scratchpad version notes:
// Doug: Do you think we could do something like breaking the version code into bitfields,
// so that if version & 0xF is 0 or 1 I know it's a lantern and the UUID can be found
// at byte 9, and if it's 3 or 4 it's a heat cycle and the UUID is at byte 29?

// So after the original 0, 1, 2, 3, 4 we started counting from the upper 4 bits

export enum ScratchpadVersion {
  LANTERN_CUSTOM = 16, // 0b00010000
  LANTERN_EXCLUSIVE = 0, // 0b00000000
  PROFILE = 2, // 0b00000010
  PROFILE_CUSTOM = 19, // 0b00010011
  PROFILE_EXCLUSIVE = 3, // 0b00000011
  BLANK = 255, // 0b11111111

  // Previous versions
  LANTERN_CUSTOM_0 = 1, // 0b00000001
  PROFILE_CUSTOM_0 = 4, // 0b00000100
}

interface VersionedScratchpad<V extends number> {
  version: V;
}

export interface ScratchpadLanternExclusive
  extends VersionedScratchpad<ScratchpadVersion.LANTERN_EXCLUSIVE> {
  moodUlid: string;
}

export interface ScratchpadLanternCustom0
  extends VersionedScratchpad<ScratchpadVersion.LANTERN_CUSTOM_0> {
  moodUlid: string;
  moodName: string;
  moodDateModified: number; // Date as seconds from UNIX epoch
  moodType: MoodType;
  tempo: number;
  colors: string[];
}

export interface ScratchpadLanternCustom
  extends VersionedScratchpad<ScratchpadVersion.LANTERN_CUSTOM> {
  moodUlid: string;
  moodName: string;
  moodDateModified: number; // Date as seconds from UNIX epoch
  moodType: MoodType;
  tempo: number;
  colors: string[];
  originalMoodUlid: string;
}

export interface ScratchpadProfile
  extends VersionedScratchpad<ScratchpadVersion.PROFILE> {
  heatProfileUlid: string;
  heatProfileDateModified: number; // Date as seconds from UNIX epoch
}

export interface ScratchpadProfileExclusive
  extends VersionedScratchpad<ScratchpadVersion.PROFILE_EXCLUSIVE> {
  moodUlid: string;
  heatProfileUlid: string;
  heatProfileDateModified: number; // Date as seconds from UNIX epoch
}

export interface ProfileCustom0
  extends VersionedScratchpad<ScratchpadVersion.PROFILE_CUSTOM_0> {
  moodUlid: string;
  moodName: string;
  moodDateModified: number; // Date as seconds from UNIX epoch
  moodType: MoodType;
  tempo: number;
  colors: string[];
  heatProfileUlid: string;
  heatProfileDateModified: number; // Date as seconds from UNIX epoch
}

export interface ScratchpadProfileCustom
  extends VersionedScratchpad<ScratchpadVersion.PROFILE_CUSTOM> {
  moodUlid: string;
  moodName: string;
  moodDateModified: number; // Date as seconds from UNIX epoch
  moodType: MoodType;
  tempo: number;
  colors: string[];
  heatProfileUlid: string;
  heatProfileDateModified: number; // Date as seconds from UNIX epoch
  originalMoodUlid: string;
}

export interface ScratchpadBlank
  extends VersionedScratchpad<ScratchpadVersion.BLANK> {
  version: 255;
}

export type ScratchpadType =
  | ScratchpadLanternCustom
  | ScratchpadLanternExclusive
  | ScratchpadProfile
  | ScratchpadProfileCustom
  | ScratchpadProfileExclusive
  | ScratchpadBlank
  | ScratchpadLanternCustom0
  | ProfileCustom0;
